import { createFileRoute } from '@tanstack/react-router';
import { ApiTokensPage } from '../features/admin/api-tokens-page.js';

export const Route = createFileRoute('/app/admin/api-tokens')({ component: ApiTokensPage });
